import { IUser } from "@/store/models";
import BaseApi   from "./base";

class AuthApi extends BaseApi {

    private static instance: AuthApi;

    constructor() {
        super();
        this.baseUrl = "/api/Identity";
    }

    public static get Instance(): AuthApi {
        if (!AuthApi.instance) {
            AuthApi.instance = new AuthApi();
        }

        return AuthApi.instance;
    }

    public setJWT(jwt: string) {
        this.api.defaults.headers.common["Authorization"] = `Token ${jwt}`;
    }

    public clearJWT() {
        delete this.api.defaults.headers.common["Authorization"];
    }

    public getUsernameExists(username: string) {
        return this.api.get(`UsernameExists/${ username }`);
    }

    public getEmailExists(email: string) {
        return this.api.get(`EmailExists/${ email }`);

    }

    public registerUser(user: IUser){

        return this.api.post("Register",user);
    }

    public authenticateUser(user: IUser){

        return this.api.post("Register",user);
    }
}

export default AuthApi.Instance;